module.exports = "/_next/static/images/background-f6804f337d4113a8672c514c3a1678d4.png";